import { useContext } from "react";
import { DragContext } from "../providers";

/**
 * Hook that returns the drag context value
 * 
 * @returns The drag context
 */
const useDrag = () => {
  const dragContext = useContext(DragContext);

  if (!dragContext) {
    throw new Error("useDrag must be used within a DragProvider");
  }

  return dragContext;
};

export default useDrag;
